import { useCallback } from 'react'

import { useFileUploadContext } from './useFileUploadContext'

type UseFileUploadTriggerStateProps = {
    onClickProp?: (event: React.MouseEvent<HTMLButtonElement>) => void
}

export function useFileUploadTriggerState({ onClickProp }: UseFileUploadTriggerStateProps) {
    const { inputRef, inputId, disabled } = useFileUploadContext()

    const onClick = useCallback(
        (event: React.MouseEvent<HTMLButtonElement>) => {
            onClickProp?.(event)

            if (event.defaultPrevented) return

            // Trigger OS file upload dialog.
            inputRef.current?.click()
        },
        [inputRef, onClickProp]
    )

    return {
        onClick,
        inputId,
        disabled,
    }
}
